/* tslint:disable:no-parameter-reassignment */
import { DetailState, RootState } from '@/store/types';
import { Module } from 'vuex';

export default {
  namespaced: true,
  state: {
    price: null
  },
  getters: {
    getPrice(state: DetailState) {
      return () => {
        if (!state.price) {
          return null;
        }
        return state.price;
      };
    }
  },
  mutations: {
    setPrice(state, price) {
      state.price = price;
    }
  }
} as Module<DetailState, RootState>;
